import { createContext } from "react";
import { Route, Routes } from "react-router-dom";
import { AgentDownlineDetailsList } from "../../modules/report/components/AgentDownlineDetails";
import { AgentDownlineReportList } from "../../modules/report/components/AgentDownlineReport";
import { GameSummary } from "../../modules/report/components/GameSummary";
import { MemberSummary } from "../../modules/report/components/MemberSummary";
import { TransactionReportList } from "../../modules/report/components/TransactionReport";

const AgentReportContext = createContext();

const AgentReportWrapper = () => {
  const value = {};

  return (
    <AgentReportContext.Provider value={value}>
      <Routes>
        <Route path="/" element={<GameSummary />} />
        <Route
          path="/agentDownlineReport"
          element={<AgentDownlineReportList />}
        />
        <Route
          path="/agentDownlineReport/:selmasterid"
          element={<AgentDownlineDetailsList />}
        />
        <Route path="/transactionReport" element={<TransactionReportList />} />
        <Route path="/gameSummaryReport" element={<MemberSummary />} />
      </Routes>
    </AgentReportContext.Provider>
  );
};

export { AgentReportWrapper };
